import React, { FC, useEffect, useMemo, useState } from 'react';
import { TreeSelect } from 'udesk-ui';
import { useCoachAllUserTreeData } from 'src/util/hook/user';

const useTreeSelect = () => {
    const { treeData: userData } = useCoachAllUserTreeData();

    const treeData = useMemo(() => {
        return userData.map((item) => ({
            id: item.id,
            pId: item.pId,
            value: item.id,
            title: item.title,
            key: item.id,
            data: item,
        }));
    }, [userData]);

    return {
        treeDataSimpleMode: true,
        treeData,
        allowClear: true,
        showArrow: true,
        filterTreeNode: true,
        showSearch: true,
        treeCheckable: true,
        treeNodeFilterProp: 'title',
        maxTagCount: 1,
    };
};

type EvaluatorTreeSelectProps = {
    value?: {
        users?: number[];
    };
    onChange?: (v?: EvaluatorTreeSelectProps['value']) => void;
    [key: string]: unknown;
};

const EvaluatorTreeSelect: FC<EvaluatorTreeSelectProps> & {
    useTreeSelect: typeof useTreeSelect;
} = (props) => {
    const { value, onChange, ...restProps } = props;
    const [innerValue, setInnerValue] = useState<string[] | string>([]);

    useEffect(() => {
        if (Array.isArray(value?.users)) {
            setInnerValue(value?.users.map((item) => `${item}/u`) || []);
        }
    }, [value?.users]);

    const onInnerChange = (v: any) => {
        let arr: number[] = [];
        if (Array.isArray(v)) {
            arr = v
                .filter((item) => item.toString().indexOf('/u') !== -1)
                .map((item) => parseInt(item));
        } else if (v !== undefined) {
            arr = [parseInt(v)];
        }
        setInnerValue(v);
        onChange?.({ users: arr });
    };

    return <TreeSelect value={innerValue} onChange={onInnerChange} {...restProps} />;
};

EvaluatorTreeSelect.useTreeSelect = useTreeSelect;

export default EvaluatorTreeSelect;
